/**
 * AreaModal
 * Modal para crear/editar áreas
 */

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { FiX } from 'react-icons/fi';
import { areaService } from '../services/catalogoService';
import './AreaModal.css';

const AreaModal = ({ isOpen, mode = 'create', area = null, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    descripcion: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (mode === 'edit' && area) {
      setFormData({
        nombre: area.nombre || '',
        descripcion: area.descripcion || ''
      });
    } else {
      setFormData({
        nombre: '',
        descripcion: ''
      });
    }
  }, [mode, area, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      toast.error('El nombre del área es requerido');
      return;
    }

    setLoading(true);
    try {
      if (mode === 'create') {
        await areaService.create({
          ...formData,
          status: 'activo'
        });
        toast.success('Área creada exitosamente');
      } else if (mode === 'edit') {
        await areaService.update(area.id, formData);
        toast.success('Área actualizada exitosamente');
      }

      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error al guardar área:', error);
      toast.error('Error al guardar el área');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="area-modal-overlay">
      <div className="area-modal">
        <div className="area-modal-header">
          <h3>{mode === 'create' ? 'Crear Área' : 'Editar Área'}</h3>
          <button onClick={onClose} className="close-btn">
            <FiX />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Nombre *</label>
            <input
              id="nombre"
              type="text"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Nombre del área"
              autoFocus
            />
          </div>

          <div className="form-group">
            <label htmlFor="descripcion">Descripción</label>
            <textarea
              id="descripcion"
              name="descripcion"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Descripción del área (opcional)"
              rows="4"
            />
          </div>

          <div className="modal-footer">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              Cancelar
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Guardando...' : mode === 'create' ? 'Crear' : 'Actualizar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AreaModal;
